export default __webpack_public_path__ + "static/media/MarkerIconTransparentGrey.e01ce184.svg";